<template>
  <div class="main">
    <div class="content">
      <ul>
        <li
          v-for="(item,index) in tabList"
          :key="index"
          @click="tabMenu(index)">
			<div class="itemImg" :class="activeIndex==index&&'active'">
				<img src="../assets/img/hoszhi.png" v-if="activeIndex==index">
				<span>{{item.text}}</span>
			</div>
        </li>
      </ul>
	  <!-- 插槽 -->
	  <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      activeIndex:0
    };
  },
  methods: {
    tabMenu(index) {
      this.activeIndex=index
	  //给父元素传递参数
      this.$emit('setIndex',index)
    },
  },
};
</script>

<style lang="less">
.main {
  width: 100%;
  background: linear-gradient(to bottom, #ffffff, #F7F7F7);
  border: 1px solid #D8D8D8;
  .content {
    width: 100%;
	height: 70px;
	ul {
      width: 100%;
	  height: 100%;
	  display: flex;
	  justify-content: flex-start;
	  align-items: center;
	  list-style-type: none;
	  background: ;
	}
	li {
	  min-width: 130px;
	  height: 43px;
	  cursor: pointer;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  .itemImg {
		  min-width: 90px;
		  height: 30px;
		  display: flex;
		  justify-content: center;
		  align-items: flex-end;
		  padding-bottom: 5px;
		  color: #818181;
		  img {
			  width: 15px;
			  height: 15px;
			  margin-right: 5px;
		  }
		  span {
		    font-size: 14px;
		    line-height: 14px;
		  }
	  }
	  
	}
  }
}
.active{
	min-width: 130px;
	border-bottom: 2px solid #D30000;
	color: #D30000 !important;
	background-color: rgba(0,0,0,0);
}
</style>